
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const REPLENISH_LINE_BASE = "/replenishlists";
const buildUrl = (endpoint) => REPLENISH_LINE_BASE + endpoint;
const ApiName = "ReplenishLists";

const replenishListApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReplenishLists: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: ApiName}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getReplenishLines', ApiName)
        }),
        getReplenishListItemsFromList: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/listitems?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}ListItems`}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getReplenishLines', ApiName)
        }),
        getReplenishList: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'ReplenishListsSingle'}],
            // onQueryStarted: muiDataGridStarted.bind(null, 'getProduct', 'Product')
        }),
        cancelListItem: builder.mutation({
            query: params => ({
                url: buildUrl(`/${params.id}/listitems/cancel/${params.itemId}`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName},{ type: 'ReplenishListsSingle'},{ type: `${ApiName}ListItems`},{ type: 'ReplenishLines'}],
        }),
        completeReplenishList: builder.mutation({
            query: id => ({
                url: buildUrl(`/complete/${id}`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, { id }) => [{ type: ApiName},{ type: 'ReplenishListsSingle'},{ type: `${ApiName}ListItems`}],
        }),
    })
});

export const {
    useGetReplenishListsQuery,
    useGetReplenishListItemsFromListQuery,
    useGetReplenishListQuery,
    useCancelListItemMutation,
    useCompleteReplenishListMutation,
  } = replenishListApiSlice;